const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
const URLRegex =
  /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

const RegionCode = {
  RegionUK: "en-GB",
  RegionUS: "en-US",
  RegionFR_CA: "fr-CA",
  RegionFR_FR: "fr-FR",
};
export { passwordRegex, RegionCode, URLRegex };
